module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/unsupported_browser.bebe4100ae7af04b515a15808abbf27c.svg";